import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Configuration } from "../services/configuration.service";

import { views } from "../../../../app/phone/views";
import { WebCallTopicService } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic.service";

const debug = false;

@Component({
  selector: "onsip-topic-list",
  templateUrl: "./topic-list.component.html",
  styleUrls: ["./topic-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TopicListComponent implements OnInit {
  /**
   * Observable that drives the list- it contains:
   * - the targetDisplay to show as the title of the list item
   * - the target to use as a unique identifier to pass into children
   *
   * if you're trying to add more to it, you're probably trying to fit something that doesn't belong here
   */
  topicPartials!: Observable<Array<Pick<Configuration, "target" | "targetDisplay">> | undefined>;

  constructor(private router: Router, private webCallTopicService: WebCallTopicService) {}

  ngOnInit() {
    this.initTopics();
  }

  navigateToView(topicTarget: string) {
    this.router.navigate([views.SAYSO_VIEW], {
      state: {
        topicTarget,
        skipLocationChange: true,
        replaceUrl: true
      }
    });
  }

  private initTopics(): void {
    debug && console.log("TopicListComponent: initTopics");
    this.topicPartials = this.webCallTopicService.orgState.pipe(
      map(topics =>
        topics
          .map(topic =>
            topic.configuration
              ? {
                  target: topic.configuration.target,
                  targetDisplay: topic.configuration.targetDisplay
                }
              : { target: topic.name, targetDisplay: topic.name }
          )
          .sort((a, b) => (a.targetDisplay.toUpperCase() >= b.targetDisplay.toUpperCase() ? 0 : -1))
      )
    );
  }
}
